const BASE_IP = `${process.env.REACT_APP_STRIPE_API_URL}`;
const SYSTEM_OF_RECORD = 'Diamond';

export const stripeGetApiText = async (path) => {
  try {
    const option = {
      headers: {
        accept: 'text/plain',
        'System-Of-Record': SYSTEM_OF_RECORD,
      },
    };

    const request = await fetch(`${BASE_IP}/${path}`, option);
    const response = await request.text();

    return request.ok ? response : null;
  } catch (_) {
    return null;
  }
};

export const stripeGetApi = async (path) => {
  try {
    const option = {
      headers: {
        'Content-Type': 'application/json',
        'System-Of-Record': SYSTEM_OF_RECORD,
      },
    };

    const request = await fetch(`${BASE_IP}/${path}`, option);
    const response = (request.ok && request.status === 200)
      ? await request.json() : null;

    return {
      data: response,
      devError: '',
      ok: request.ok,
      status: request.status,
    };
  } catch (_) {
    return {
      data: null,
      devError: _.message,
      ok: false,
      status: 500,
    };
  }
};

export const stripePostApi = async ({ body, path }) => {
  try {
    const option = {
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        'System-Of-Record': SYSTEM_OF_RECORD,
      },
      method: 'POST',
    };

    const request = await fetch(`${BASE_IP}/${path}`, option);
    const response = (request.ok) ? await request.json() : null;

    return {
      data: response,
      devError: '',
      ok: request.ok,
      status: request.status,
    };
  } catch (_) {
    return {
      data: null,
      devError: _.message,
      ok: false,
      status: 500,
    };
  }
};
